import React, { useMemo } from 'react';
import Select from 'react-select';


export type GeneralSelectorOption = {
    id: any
    name: string
}

export interface PersonSelectorProps {
    initValue?: any;
    onChange: (value: GeneralSelectorOption | undefined) => void;
    placeholder?: string;
    label?: string;
    clearable?: boolean;
    hasTitle?: boolean
    disabled?: boolean
    data: GeneralSelectorOption[]
}

const GeneralSelector: React.FC<PersonSelectorProps> = ({
    initValue,
    onChange,
    placeholder = 'Enter or Select',
    label = 'Mill',
    clearable = false,
    hasTitle = true,
    disabled = false,
    data
}) => {

    const options = useMemo(() => {
        return (data || []).filter(a => a.name).sort((d1, d2) => d1.name!.localeCompare(d2.name!)).map((entry: GeneralSelectorOption) => ({
            value: entry,
            label: `${entry.name}`
        }));
    }, [data]);

    const selectedOption = useMemo(() => {
        return options.find((opt: { value: GeneralSelectorOption; label: string | number }) => opt.value.id === initValue) || null;
    }, [options, initValue]);

    return (
        <div className="pempem-flexleft" style={{ width: '200px' }}>
            {label && hasTitle && <label className="pempem-bold">{label}</label>}
            <div style={{ flex: 1, minWidth: 0 }}>
                <Select
                    isDisabled={disabled}
                    value={selectedOption}
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                        container: base => ({ ...base, width: '100%' })
                    }}
                    onChange={opt => { console.log(opt); onChange(opt ? (opt as any).value : undefined) }}
                    options={options}
                    isClearable={clearable}
                    placeholder={placeholder}
                />
            </div>
        </div>
    );
};

export default GeneralSelector;
